'use client';
import { useRef, useEffect } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import classNames from 'classnames';

interface VideoFile {
  url: string;
  metadata?: {
    mimeType?: string;
  };
}

interface AutoplayVideoProps {
  videoFile: VideoFile;
  setAspectRatio?: string | null;
  autoPlay?: boolean | null;
}

const AutoplayVideo = ({
  videoFile,
  setAspectRatio = null,
  autoPlay = true,
}: AutoplayVideoProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const shouldAutoPlay = autoPlay !== false;

  useEffect(() => {
    if (videoRef.current) {
      videojs(videoRef.current, {
        sources: [
          {
            src: videoFile.url,
            type: videoFile.metadata?.mimeType,
          },
        ],
      });
    }
  }, [videoFile.url, videoFile.metadata?.mimeType, setAspectRatio, autoPlay]);

  const containerClasses = classNames(
    'relative w-full overflow-hidden flex items-center justify-center',
    setAspectRatio
  );

  return (
    // Fixed aspect ratio, fill container
    <div className={setAspectRatio ? containerClasses : 'w-full'}>
      <video
        autoPlay={shouldAutoPlay}
        muted={shouldAutoPlay}
        loop={shouldAutoPlay}
        playsInline
        controls={!shouldAutoPlay}
        ref={videoRef}
        className={`video-js vjs-fluid object-cover`}
        style={{ objectFit: 'cover' }}
      />
    </div>
  );
};

export default AutoplayVideo;
